<template>
  <div v-if="obj" :class="'callout callout-' + obj.type">
    <p v-html="obj.text"></p>
    <i class="fa fa-close" @click="hide()"></i>
  </div>
</template>


<script>
  export default {
    props: {
      'hideMutationType': String,
      'obj': Object,
    },
    methods: {
      hide: function () {
        this.$store.commit(this.hideMutationType)
      },
    },
  }
</script>

<style lang="scss">
  .callout {
    position: relative;

    p {
      margin: 0;
    }

    i {
      position: absolute;
      top: 8px;
      right: 9px;
      font-size: 16px;
      color: #EBEAEF;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// Message.vue?28e6944a